import { FETCH_PAYMENT_TYPES } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const paymentTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_TYPES:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default paymentTypesReducer;
